/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChatConversationFilter {
    getFixupPrototypeFunction() { return ChatConversationFilter.fixupPrototype; }

    static newInstance(model: Partial<ChatConversationFilter>): ChatConversationFilter {
        let obj = Object.assign(new ChatConversationFilter(), model);
        ChatConversationFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChatConversationFilter>): ChatConversationFilter {
        if (!model) return null;
        return ChatConversationFilter.newInstance(<ChatConversationFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChatConversationFilter) {
        if (!obj) return;

        models.ChatConversationFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChatConversationFilter): boolean {
        Object.setPrototypeOf(obj, ChatConversationFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the agent type
     */
    chat_id: string;

}
